'use client';
import { useSettings } from './use-settings.js';
/**
 * Hook to check if the layout is vertical
 * @example
 * ```ts
 * import { useIsVertical } from "@cloud/shared/ui"
 *
 * const isVertical = useIsVertical()
 * ```
 */
export function useIsVertical() {
    const { settings } = useSettings();
    const isVertical = settings.layout === 'vertical';
    return isVertical;
}
